module.exports = __webpack_public_path__ + "img/banner_blackfriday.9d83da3e.gif";